var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"masked-amount"},[(_vm.balanceVisible)?_vm._t("visible"):_vm._t("hidden",function(){return [_c('span',{staticClass:"masked-amount-placeholder"},[_vm._v(_vm._s(_vm.placeholder))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }